import format from 'date-fns/format';
import get from 'lodash/get';
import has from 'lodash/has';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';

const getUserData = data => {
  const userData = {};
  if (data === null || !has(data, 'viewer.person')) {
    return userData;
  }
  const email = get(data, 'viewer.person.email');
  if (!isEmpty(email)) {
    userData.em = email.toLowerCase();
  }
  const firstName = get(data, 'viewer.person.first');
  if (!isEmpty(firstName)) {
    userData.fn = firstName.toLowerCase();
  }
  const lastName = get(data, 'viewer.person.last');
  if (!isEmpty(lastName)) {
    userData.ln = lastName.toLowerCase();
  }
  const gender = get(data, 'viewer.person.gender');
  if (!isEmpty(gender) && includes(['m', 'f'], gender)) {
    userData.ge = gender;
  }
  const birthdate = get(data, 'viewer.person.birthdate');
  if (!isEmpty(birthdate)) {
    userData.db = format(birthdate, 'YYYYMMDD');
  }
  const city = get(data, 'viewer.person.address.city');
  if (!isEmpty(city)) {
    userData.ct = city.toLowerCase().replace(' ', '');
  }
  const state = get(data, 'viewer.person.address.state');
  if (!isEmpty(state)) {
    userData.st = state.toLowerCase();
  }
  const postalCode = get(data, 'viewer.person.address.postalCode');
  if (!isEmpty(postalCode)) {
    userData.zp = postalCode;
  }
  const phoneNumber = get(data, 'viewer.person.phoneNumber');
  if (!isEmpty(phoneNumber)) {
    userData.ph = phoneNumber;
  }
  return userData;
};

export default class FacebookTracker {
  constructor(id) {
    this.id = id;
  }
  init = async data => {
    const userData = getUserData(data);
    if (typeof window !== 'undefined') {
      try {
        if (!this.fbPixel) {
          this.fbPixel = (await import('react-facebook-pixel')).default;
        }
        if (this.fbPixel && this.fbPixel.init) {
          this.fbPixel.init(
            this.id,
            !isEmpty(userData)
              ? userData
              : null,
            {
              debug: process.env.NODE_ENV === 'development',
            },
          );
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Facebook tracker initializatin failed.', e);
      }
    }
  };
  trackEvent = (event, params, data) => {
    this.init(data);
    if (this.fbPixel && this.fbPixel.fbq) {
      this.fbPixel.fbq(
        'trackSingle',
        this.id,
        event,
        params,
      );
    }
  };
  trackCustomEvent = (event, params, data) => {
    this.init(data);
    if (this.fbPixel && this.fbPixel.fbq) {
      this.fbPixel.fbq(
        'trackSingleCustom',
        this.id,
        event,
        params,
      );
    }
  };
  trackPageView = data => {
    this.init(data);
    if (this.fbPixel && this.fbPixel.fbq) {
      this.fbPixel.fbq(
        'trackSingle',
        this.id,
        'PageView',
      );
    }
  }
}
